/**
 * Core – Billing, payment, subscription, addons
 */

export default {
  payment: {
    desc: "Description",
    unitPrice: "Unit price",
    qty: "Qty",
    total: "Total",
    subTotal: "Subtotal",
    promo: "Promo-code Discount",
    apply: "Apply",
    promoApplied: "Promo-code has been applied.",
    invalidePromo: "Invalide promo-code.",
    orderInv: "order an invoice",
    reqOfFunds: "Request of funds",
  },
  billing: {
    title: "Billing history",
    dateTime: "Date",
    action: "Action",
    number: "Number",
    amount: "Amount",
    addPaymentTitle: "Add payment",
    addPaymentDescription: "Please enter payment information",
    addPaymentError: "Error",
    addPaymentSuccessMessage: "Payment has been successfully added",
    paymentNumber: "Payment number",
    invoiceLabel: "Invoice",
    invoiceType: "Invoice type",
    sum: "Sum",
    currency: "Currency",
    showing: "Showing",
    of: "of",
    results: "results",
    pay: "Pay",
    cancel: "Cancel",
    status: "Status",
    delete: "Delete",
    edit: "Edit",
    description: "Here you will find all your invoices",
    addDocument: "Add document",
    addPayment: "Add payment",
    addInvoice: "Add invoice",
    updateXero: "Update Xero",
    invoices: "Invoices",
    payments: "Payments",
    xeroInvoicesUpdated: "Xero invoices has been successfully updated",
    xeroInvoicesError: "Xero invoices update error",
    xeroPaymentsUpdated: "Xero payments has been successfully updated",
    xeroPaymentsError: "Xero payments update error",
    xeroInvoicesUpdating: "Xero invoices updating",
    xeroPaymentsUpdating: "Xero payments updating",
    noInvoices: "You don't have any invoices yet",
    addFile: "Add file",
    choosePdf: "Choose *pdf file to upload",
    invoiceNumber: "Invoice number",
    editInvoice: "Edit invoice",
    doYouWantToPayCharge: "Do you want to pay Charge invoice from",
    for: "for",
    confirmDelete: "Confirm Delete",
    areYouSureDel: "Are you sure you want to delete",
    company_name: "Company name",
    client: "Client",
    banks: "Banks",
    discount: "Discount",
    comment: "Comment",
    additionalType: "Additional type",
    quantityLabel: "Quantity",
    yearFrom: "Year from",
    yearTill: "Year till",
    declarationType: "Declaration type",
    notSelected: "Not selected",
    enterAddonQuantity: "Enter addon quantity",
  },
  subscription: {
    subPlans: "Subscription plans",
    selectPlan: "Select plan",
    addons: "Addons",
    addonName: "Addon name",
    from: "From",
    till: "Till",
    country: "Country",
    subs: "Subscribe",
    orderInv: "Order an invoice",
    iAgree: "I agree the payment will be forwarded to my Shopify account.",
    plan: "Plan",
    price: "Price",
    quantity: "Quantity",
    total: "Total",
    subTotal: "Total",
    promoDisc: "Promo-code Discount",
    enterPromo: "Enter promo-code",
    apply: "Apply",
    promoApplied: "Promo-code has been applied.",
    promoInvalid: "Invalid promo-code",
    payment: "Payment",
    thanksForReq:
      "Thank you for your request! You will be emailed with the invoice and further instructions within several hours.",
    planPrices: {
      whenAnnually: "Monthly price when billed annually",
      monthly: "Monthly price",
      integ: "Integrations",
      totalTrans: "Total value of transactions per month",
      numberOfTrans: "Number of transactions per month",
      threshold: "Threshold calculation",
      list: "ES list of sales",
      intrastat: "Intrastat",
      support: "Consultations support",
      countries: "Countries",
      packaging: "Packaging",
    },
    detailsPlan: "Details of the selected plan",
    detailsAddons: "Details of the selected addons",
    commentForOrder: "Comment for the order",
    included: "included",
    add: {
      addCountry: "Each additional country",
      addTrans: "Additional number of transactions (per 5 000)",
      addForEach: "Additional value for each 100.000",
      list: "Sales list per country",
      support: "Consultations support per hour",
      taxRepr: "Tax representative",
      countries: "Selected countries",
    },
    jan: "January",
    feb: "February",
    mar: "March",
    apr: "April",
    may: "May",
    june: "June",
    july: "July",
    aug: "August",
    sept: "September",
    oct: "October",
    nov: "November",
    dec: "December",
    janSh: "Jan",
    febSh: "Feb",
    marSh: "Mar",
    aprSh: "Apr",
    maySh: "May",
    juneSh: "Jun",
    julySh: "Jul",
    augSh: "Aug",
    septSh: "Sep",
    octSh: "Oct",
    novSh: "Nov",
    decSh: "Dec",
    annually: "Annually",
    monthly: "Monthly",
    required: "required",
    hoursPer1: "",
    hoursPer2: "hours per month",
    mostPopular: "MOST POPULAR",
    addInput: {
      addCountry: "Additional country",
      addTrans: "Additional transactions",
      addRev: "Additional revenue",
      list: "List of sales",
      support: "Consultations support",
      taxRepr: "Tax rep",
    },
  },
  addons: {
    buyAddons: "Buy addons",
    from: "From",
    till: "Till",
    country: "Country",
    annually: "Annually",
    monthly: "Monthly",
    subs: "Subscribe",
    orderInv: "Order an invoice",
    iAgree: "I agree the payment will be forwarded to my Shopify account.",
    plan: "Plan",
    price: "Price",
    quantity: "Quantity",
    total: "Total",
    subTotal: "Subtotal",
    promoDisc: "Promo-code Discount",
    enterPromo: "Enter promo-code",
    apply: "Apply",
    promoApplied: "Promo-code has been applied.",
    promoInvalid: "Invalid promo-code",
    payment: "Payment",
    thanksForReq:
      "Thank you for your request! You will be emailed with the invoice and further instructions within several hours.",
    add: {
      addCountry: "Each additional country",
      addTrans: "Additional number of transactions (per 5 000)",
      addForEach: "Additional value for each 100.000",
      list: "Sales list per country",
      support: "Consultations support per hour",
      taxRepr: "Tax representative",
    },
    addInput: {
      addCountry: "Additional country",
      addTrans: "Additional transactions",
      addRev: "Additional revenue",
      list: "List of sales",
      intrastat: "Intrastat",
      support: "Consultations support",
      taxRepr: "Tax rep",
    },
    jan: "January",
    feb: "February",
    mar: "March",
    apr: "April",
    may: "May",
    june: "June",
    july: "July",
    aug: "August",
    sept: "September",
    oct: "October",
    nov: "November",
    dec: "December",
    janSh: "Jan",
    febSh: "Feb",
    marSh: "Mar",
    aprSh: "Apr",
    maySh: "May",
    juneSh: "Jun",
    julySh: "Jul",
    augSh: "Aug",
    septSh: "Sep",
    octSh: "Oct",
    novSh: "Nov",
    decSh: "Dec",
    currentPlan: "Current plan",
    infoCurrent: "Information about the current tariff plan",
    tariffPlan: "Tariff plan",
    yourMemb1: "Your membership is",
    yourMemb2: " / month",
    addons: "Addons",
    selectAddons: "You can select additional addons here.",
    detailsAddons: "Details of the selected addons",
    fillInDetails: "Please fill in details of the selected addons",
    notSelected: "No addons are selected",
    addonName: "Addon name",
    required: "required",
  },
};
